import { EDataType, EGeoName, ECategory } from '../repositories/valuation-market-analytics/v1/get-chart';

export { EDataType, EGeoName, ECategory };

export enum ETrend {
  Increase = 'increase',
  Decrease = 'decrease',
  NoChange = 'noChange',
}

export enum EDealType {
  Sale = 'sale',
  Rent = 'rent',
}

export interface ISelectorValue<V> {
  value: V;
  label: string;
}

export enum ESiteType {
  desktop = 'desktop',
  mobile = 'mobile',
  tablet = 'tablet',
}

export enum EBlockInPageName {
  AveragePrice = 'AveragePrice',
  Demand = 'Demand',
  Supply = 'Supply',
  MortgageRate = 'MortgageRate',
  MoreInfo = 'MoreInfo',
}
